// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"J2-z","displaySixCardTiles":"K2-z"};